module.exports = __webpack_public_path__ + "img/icon_events.b80f3dda.svg";